export default __webpack_public_path__ + "static/media/leafjet.ff059041.svg";